<template>
    <div>
        <PreviewModal ref="preview_modal"></PreviewModal>
        <el-button type="text" class="py-0" @click="backToSelections">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 320 512"><path fill="currentColor" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>
            Back
        </el-button>
        <div v-if="selected_project">
            <h3 class="text-md">{{ selected_project.project_name }}</h3>
            <b-row class="mb-2">
                <b-col cols="auto" class="pr-md-1">
                    <el-image
                        style="width: 100px; height: 100px"
                        class="rounded mr-2"
                        :src="selected_project.project_cover_image"
                        fit="cover"
                    ></el-image>
                </b-col>
                <b-col cols="auto" class="pl-md-1">
                    <div class="d-flex align-items-center mb-2">
                        <span class="text-muted">{{ selected_project.project_location }}</span>
                        <b-icon icon="circle-fill" font-scale="0.5" class="text-muted mx-2"></b-icon>
                        <span class="text-muted">{{ selected_project.unit_total}} units</span>
                        <b-icon icon="circle-fill" font-scale="0.5" class="text-muted mx-2"></b-icon>
                        <span v-if="selected_project.project_stage_id === 1" class="text-muted">Under Construction</span>
                        <span v-else-if="selected_project.project_stage_id === 2" class="text-muted">Completed</span>
                        <span v-else-if="selected_project.project_stage_id === 3" class="text-muted">Sub Sale</span>
                        <span v-else class="text-muted">Rental</span>
                        <b-icon icon="circle-fill" font-scale="0.5" class="text-muted mx-2"></b-icon>
                        <span class="text-muted" v-if="builtUpRange.minBuiltUp !== builtUpRange.maxBuiltUp">{{ builtUpRange.minBuiltUp }} - {{ builtUpRange.maxBuiltUp }} sqft</span>
                        <span class="text-muted" v-else>{{ selected_project.unit_types[0].built_up || '-' }} sqft</span>
                    </div>
                    <b-row>
                        <b-col cols="auto">
                            <p class="text-xs text-muted">Date of Completion</p>
                            <p>{{ selected_project.project_completion_date | dateFormatString }}</p>
                        </b-col>
                        <b-col cols="auto">
                            <p class="text-xs text-muted">Lease Type</p>
                            <p v-if="selected_project.project_lease_type_id === 1">Freehold</p>
                            <p v-else>Leasehold</p>
                        </b-col>
                        <b-col cols="auto">
                            <p class="text-xs text-muted">Developer</p>
                            <p v-if="selected_project.project_source_type == 'HESTIA' && selected_project.project_developer">{{ selected_project.project_developer.name }}</p>
                            <p v-else>{{ selected_project.project_developer }}</p>
                        </b-col>
                        <b-col cols="auto">
                            <p class="text-xs text-muted">Booking Fee</p>
                            <p>N/A</p>
                        </b-col>
                        <b-col cols="auto">
                            <p class="text-xs text-muted">Buyer Discount</p>
                            <el-button type="text" class="py-0" disabled>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512"><path fill="#5D79E3" d="M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480v-83.6c0-4 1.5-7.8 4.2-10.7l167.6-182.9c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8l-88.3-44.2C7.1 311.3.3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"/></svg>
                                Send a message
                            </el-button>
                        </b-col>
                    </b-row>
                    <div>
                        <span 
                            class="text-xs cursor-pointer text-primary" 
                            :class="visible ? null : 'collapsed'"
                            :aria-expanded="visible ? 'true' : 'false'"
                            aria-controls="'collapse-unit-details'"
                            @click="visible = !visible"
                        >
                            View {{ visible ? 'less' : 'more' }} details
                        </span>
                    </div>
                </b-col>
            </b-row>
            <b-collapse id="collapse-unit-details" v-model="visible">
                <div class="bg-gradient-secondary border rounded p-3 mb-3">
                    <div class="mb-3">
                        <p class="text-muted">Description</p>
                        <p>{{ selected_project.project_description }}</p>
                    </div>
                    <div class="border-bottom pb-3">
                        <p class="text-muted">Fees</p>
                        <div class="d-flex align-items-center">
                            <div class="mr-3">
                                <b-icon icon="check-lg" class="text-success mr-2"></b-icon>
                                <span>S&amp;P Agreement Fee</span>
                            </div>
                            <div class="mr-3">
                                <b-icon icon="check-lg" class="text-success mr-2"></b-icon>
                                <span>Legal Fee</span>
                            </div>
                            <div class="mr-3">
                                <b-icon icon="check-lg" class="text-success mr-2"></b-icon>
                                <span>MOT Fee</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="selected_project.unit_types.length > 0" class="border-bottom py-3">
                        <p class="text-muted">Floor Plan</p>
                        <b-row>
                            <b-col cols="auto" v-for="(plan, index) in selected_project.unit_types" :key="index">
                                <div class="d-flex align-items-center">
                                    <p class="text-primary mr-2">{{ plan.unit_type_name }}</p>
                                    <div class="d-flex align-items-center  mr-2">
                                        <span class="pr-1 text-xs">{{ plan.bedroom }}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M2 19v-6q0-.675.275-1.225T3 10.8V8q0-1.25.875-2.125T6 5h4q.575 0 1.075.213T12 5.8q.425-.375.925-.587T14 5h4q1.25 0 2.125.875T21 8v2.8q.45.425.725.975T22 13v6h-2v-2H4v2zm11-9h6V8q0-.425-.288-.712T18 7h-4q-.425 0-.712.288T13 8zm-8 0h6V8q0-.425-.288-.712T10 7H6q-.425 0-.712.288T5 8z"/></svg>
                                    </div>
                                    <div class="d-flex align-items-center mr-2">
                                        <span class="pr-1 text-xs">{{ plan.bathroom }}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M96 77.3C96 70 101.9 64 109.3 64c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9c-3.6 9-5.6 18.9-5.6 29.2 0 19.9 7.2 38 19.2 52-5.3 9.2-4 21.1 3.8 29 9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5l-14.9-14.9C149.4 8.1 129.7 0 109.3 0 66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32h448c17.7 0 32-14.3 32-32s-14.3-32-32-32H96zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-16h256v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-40.4c19.6-17.6 32-43.1 32-71.6v-16z"/></svg>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <span class="pr-1 text-xs">{{ plan.car_park }}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M135.2 117.4 109.1 192h293.8l-26.1-74.6c-4.5-12.8-16.6-21.4-30.2-21.4H165.4c-13.6 0-25.7 8.6-30.2 21.4m-95.6 79.4L74.8 96.3C88.3 57.8 124.6 32 165.4 32h181.2c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-48H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V256c0-26.7 16.4-49.6 39.6-59.2M128 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0m288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64"/></svg>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="selected_project.project_files.length > 0" class="border-bottom py-3">
                        <p class="text-muted">Project File</p>
                        <b-row>
                            <b-col cols="auto" v-for="(file, index) in selected_project.project_files" class="d-flex align-items-center text-primary" :key="index">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 384 512"><path fill="currentColor" d="M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm384 64H256V0z"/></svg>
                                <el-tooltip effect="dark" :content="file.original_file_name || file.original_filename">
                                    <a href="javascript:void(0)" v-if="selected_project.project_source_type === 'PMP'" class="ml-1" @click="$refs.preview_modal.preview(
                                        file.attach_file_path || file.path,
                                        file.original_file_name || file.original_filename
                                    )">{{ file.original_file_name || file.original_filename | shortenText(30) }}</a>
                                    <a v-else :href="file.url" target="_blank" class="ml-1">
                                        {{ file.original_file_name || file.original_filename | shortenText(30) }}
                                    </a>
                                </el-tooltip>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="py-3">
                        <div class="d-flex align-items-center">
                            <p class="text-muted mr-3">Recommend Bank</p>
                        </div>
                        <b-row class="mt-2 no-gutters">
                            <b-col cols="auto" v-for="(bank, index) in selected_project.project_banks" :key="index">
                                <el-tooltip effect="dark" :content="bank.bank_name || bank.bank_detail.name">
                                    <el-image style="max-width: 150px" :src="_gFile.getBankLogo(bank.bank_id)" fit="contain">
                                        <template #error>
                                            <div class="image-slot">
                                                <span class="text-dark text-xs text-truncate px-md-4 px-2 pt-1">{{ bank.bank_code || bank.bank_detail.code }}</span>
                                            </div>
                                        </template>
                                    </el-image>
                                </el-tooltip>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-collapse>
            <SelectUnit :selected_project="selected_project" :is_proposal="is_proposal" />
        </div>
        <div v-else>
            No Property Selected
        </div>
    </div>
</template>
<script>
import { Image, Button, Tooltip } from 'element-ui'
import SelectUnit from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/PropertySolution/SelectUnit'
import PreviewModal  from '@/components/Modal/PreviewModal'

export default {
    props: {
        selected_project: {
            type: Object
        },
        is_proposal:{
            type: Boolean,
        }
    },
    components: {
        SelectUnit,
        PreviewModal,
        [Image.name]: Image,
        [Button.name]: Button,
        [Tooltip.name]: Tooltip,
    },
    data() {
        return {
            visible: true
        }
    },
    computed: {
        builtUpRange() {
            const builtUpValues = this.selected_project.unit_types.map(unit => unit.built_up)
            const minBuiltUp = Math.min(...builtUpValues)
            const maxBuiltUp = Math.max(...builtUpValues)
            return { minBuiltUp, maxBuiltUp }
        },
    },
    methods: {
        backToSelections() {
            this.$emit('back');
        }
    }
}
</script>